import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { HelpersService } from '../services/helpers.service';
@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {

    constructor(private helpersService: HelpersService,
                private router: Router) {}

    canActivate(): boolean {
        return this.isLogged();
    }

    private isLogged(): boolean {
        let canRoute = false;
        if (this.helpersService.isLogged) {
            canRoute = true;
        } else {
            canRoute = false;
            this.router.navigateByUrl('/login');
        }
        return canRoute;
    }
}
